import _ from 'lodash';
import template from 'url-template';

import {
    FETCH_USER_SUBSCRIPTIONS,
    FETCH_CONTACT_SUBSCRIPTIONS,
    SET_SUBSCRIPTION
} from './actionTypes';

import awsHeader from '../helpers/awsAuth';
import lambdaBaseApi from '../apis/lambda';

import { enqueueSnackbar, handleNetworkError } from './applicationMessageActions';

const SubscriptionsUrl = template.parse('/subscriptions{?page,pageSize,type}');
const SubscriptionUrl = template.parse('/subscriptions/{subscriptionId}');

const DEFAULT_PAGE_SIZE = 1000;
const DEFAULT_PAGE = 1;

export const fetchSubscriptions = (type, options = {}) => async (dispatch) => {
    const header = await awsHeader();

    options.type || (options.type = type);
    options.pageSize || (options.pageSize = DEFAULT_PAGE_SIZE);
    options.page || (options.page = DEFAULT_PAGE);

    try {
        const result = await lambdaBaseApi.get(
            SubscriptionsUrl.expand({
                ...options
            }),
            header
        );

        const payload = _.get(result, 'data.data', []);

        switch (type) {
            case 'users':
                dispatch({
                    type: FETCH_USER_SUBSCRIPTIONS,
                    payload
                });
                break;
            case 'contacts':
                dispatch({
                    type: FETCH_CONTACT_SUBSCRIPTIONS,
                    payload
                });
                break;
            default:
                break;
        }

        return true;

    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

export const unsubscribe = (subscriptionId, type) => async (dispatch) => {
    const header = await awsHeader();

    try {
        await lambdaBaseApi.delete(
            SubscriptionUrl.expand({ subscriptionId }),
            header
        );


        dispatch(fetchSubscriptions(type));
        dispatch(enqueueSnackbar('Unsubscribed successfully.', 'success'));

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

export const updateSubscription = body => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        await lambdaBaseApi.patch(
            SubscriptionsUrl.expand({}),
            body,
            header
        );

        let type;

        switch (body.subscribers[0].subscribertype) {
            case 'user':
                type = 'users';
                break;
            case 'contact':
                type = 'contacts';
                break;
            default:
                break;
        }

        await dispatch(fetchSubscriptions(type));
        dispatch(enqueueSnackbar('Subscription updated successfully.', 'success'));

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

export const setSubscription = subscription => ({
    type:    SET_SUBSCRIPTION,
    payload: subscription
});
